<json-editor #editor [options]="editorOptions" [data]="editorData" (change)="changeLog($event)"></json-editor>

